export enum EntityType {
    Order = 'Order'
}
